import { II9OnboardingInfo, ZealApiResponse } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TUpdateI9AdminReviewRequest } from "./updateI9AdminReviewSchema";

export const updateI9AdminReview = (axios: IAxiosInstance) => {
  return async (data: TUpdateI9AdminReviewRequest) => {
    const response = await axios.noRetry.patch<
      ZealApiResponse<II9OnboardingInfo>
    >(`/api/updateI9AdminReview`, { ...data });
    const resData = response.data;
    if (resData.success) {
      return resData.data;
    }
    throw new Error("Something went wrong");
  };
};
